import { LogicalFilter, LogicalOperator } from '@hello-aria/query-string'
import { ComparisonFilterInput, NestedLogicalFilterInput } from '@hello-aria/query-string/dist/stringify'
import { isArray, isEmpty, isNil } from 'lodash'
import { Loan, LoanStatus, STATUSES_EXEMPT_FROM_INVOICE_REQUIREMENT } from '../models/loanModels'

export const getCountByStatus = (
    loans: Pick<Loan, 'amount' | 'status'>[] | null | undefined,
    status: LoanStatus | LoanStatus[]
): number => {
    if (isNil(loans) || isEmpty(loans)) {
        return 0
    }

    return loans.reduce((acc, loan) => {
        const shouldCount = isArray(status) ? status.includes(loan.status) : loan.status === status
        if (shouldCount) acc++
        return acc
    }, 0)
}

export const getAmountByStatus = (
    loans: Pick<Loan, 'amount' | 'status'>[] | null | undefined,
    status: LoanStatus | LoanStatus[]
): number => {
    if (isNil(loans) || isEmpty(loans)) {
        return 0
    }

    return loans.reduce((acc, loan) => {
        const shouldCount = isArray(status) ? status.includes(loan.status) : loan.status === status
        if (shouldCount) acc += loan.amount
        return acc
    }, 0)
}

export interface ResolveLoansFilters {
    type: LogicalFilter['type']
    operator: LogicalOperator
    filters: (
        | ComparisonFilterInput
        | {
              type: LogicalFilter['type']
              operator: LogicalOperator
              filters: ComparisonFilterInput[]
          }
    )[]
}

export type ResolveLoansFiltersParams = {
    customFilters?: (ComparisonFilterInput | NestedLogicalFilterInput)[]
}

export const resolveLoanFilters = ({ customFilters }: ResolveLoansFiltersParams): ResolveLoansFilters => {
    const filters: (ComparisonFilterInput | NestedLogicalFilterInput)[] = customFilters ?? []

    return {
        type: 'logical',
        operator: 'and',
        filters
    }
}

export const shouldDisplayInvoiceWarnings = (status: LoanStatus | undefined): boolean => {
    if (!status) return true
    return !STATUSES_EXEMPT_FROM_INVOICE_REQUIREMENT.includes(status)
}
